// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import moment from 'moment-timezone';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import Autocomplete from 'react-google-autocomplete';
import TimePicker from '../../utils/FormWidgets/TimePicker';
import DatePicker from '../../utils/FormWidgets/DatePicker';
import Rq from '../../utils/FormWidgets/RequireField';
import {
  getTimeWithOffset,
  getLocationDescription,
} from '../../../infrastructure/utils/common';
import { setTopPosition } from '../../utils/Styles/SetTopPosition';

export default class TransportForm extends React.Component {
  instancePickup = React.createRef();
  instanceDropoff = React.createRef();

  componentDidUpdate() {
    if (!this.instancePickup.current || !this.instanceDropoff.current) {
      return;
    }

    this.onFocus();
  }

  onFocus = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.instancePickup.current.addEventListener('focusin', () => {
      setTopPosition('.pac-container', this.instancePickup);
    });
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.instanceDropoff.current.addEventListener('focusin', () => {
      setTopPosition('.pac-container', this.instanceDropoff);
    });
  };

  handleNameChange = ({ target }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    handleTravelDataChange({
      ...event,
      eventName: target.value,
    });
  };

  fromPlaceSelected = async val => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    if (val.place_id === undefined) {
      return;
    }
    const location = await getLocationDescription(val, true);
    handleTravelDataChange({
      ...event,
      eventLocationFrom: location,
    });
  };

  fromPlaceChanged = ({ target }) => {
    setTopPosition('.pac-container', this.instancePickup);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    const newLocation = {
      address: target.value.length > 0 ? target.value : undefined,
    };
    handleTravelDataChange({
      ...event,
      eventLocationFrom: newLocation,
    });
  };

  toPlaceSelected = async val => {
    if (val.place_id === undefined) {
      return;
    }
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    const location = await getLocationDescription(val, true);
    handleTravelDataChange({
      ...event,
      eventLocationTo: location,
    });
  };

  toPlaceChanged = ({ target }) => {
    setTopPosition('.pac-container', this.instanceDropoff);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    const newLocation = {
      address: target.value,
    };
    handleTravelDataChange({
      ...event,
      eventLocationTo: newLocation,
    });
  };

  handleCheckoutDateChange = value => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    handleTravelDataChange({
      ...event,
      checkoutDate: value,
    });
  };

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      labels,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      event,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleDateChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      startDate,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      disabledDays,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      TBDTime,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      endDate,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleStartTimeChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      tz,
    } = this.props;
    return (
      <Fragment>
        <FormGroup controlId='eventName'>
          <ControlLabel>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {labels.NameLabel}
            <Rq />
          </ControlLabel>
          <FormControl
            type='text'
            onChange={this.handleNameChange}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            value={event.eventName}
          />
        </FormGroup>
        <div
          className='day-picker-inp col-md-4 col-sm-4 col-xs-8'
          style={{ paddingLeft: '0px', marginRight: ' 15px' }}
        >
          <FormGroup controlId='eventDate'>
            <DatePicker
              label='Date'
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              value={event.eventDate}
              placeholder='TBD'
              handleChange={handleDateChange}
              dayPickerProps={{
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                initialMonth: getTimeWithOffset(
                  moment(startDate).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
                ),
                modifiers: {
                  disabled: [
                    {
                      daysOfWeek: disabledDays,
                    },
                    {
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      before: getTimeWithOffset(
                        moment(startDate).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
                      ),
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      after: getTimeWithOffset(
                        moment(endDate).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
                      ),
                    },
                  ],
                },
              }}
            />
          </FormGroup>
        </div>
        <FormGroup
          controlId='startTime'
          className='col-md-4 col-sm-4 col-xs-8'
          style={{ paddingLeft: '0px', marginRight: '15px' }}
        >
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <ControlLabel>{`${labels.FromTimeLabel}`}</ControlLabel>
          <TimePicker
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            onChange={handleStartTimeChange}
            tbd={TBDTime}
            placeholder='TBD'
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            value={event.startTime}
          />
        </FormGroup>
        <div className='clearfix' />
        <FormGroup>
          <ControlLabel>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {labels.FromLabel}
            <Rq />
          </ControlLabel>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <div ref={this.instancePickup}>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <Autocomplete
                  className='form-control'
                  types={['establishment']}
                  onPlaceSelected={this.fromPlaceSelected}
                  onChange={this.fromPlaceChanged}
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  value={event.eventLocationFrom.address}
                />
              }
            </div>
          }
        </FormGroup>
        <FormGroup>
          <ControlLabel>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {labels.ToLabel}
            <Rq />
          </ControlLabel>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <div ref={this.instanceDropoff}>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <Autocomplete
                  className='form-control'
                  types={['establishment']}
                  onPlaceSelected={this.toPlaceSelected}
                  onChange={this.toPlaceChanged}
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  value={event.eventLocationTo.address}
                />
              }
            </div>
          }
        </FormGroup>
      </Fragment>
    );
  }
}
